export const ACTION_TYPE = {
  ADD_USER: "ADD_USER",
  UPDATE_TIME: "UPDATE_TIME",
  ADD_FOCUS: "ADD_FOCUS",
  EDIT_FOCUS: "EDIT_FOCUS",
  COMPLETE_FOCUS: "COMPLETE_FOCUS",
  CLEAR_FOCUS: "CLEAR_FOCUS",
  ADD_TODO: "ADD_TODO",
  COMPLETE_TODO: "COMPLETE_TODO",
  REMOVE_TODO: "REMOVE_TODO",
  OPEN_TODO: "OPEN_TODO",
  CURRENT_TODO: "CURRENT_TODO",
  CREATE_TODO: "CREATE_TODO",
};
